import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CustomStepIcon from './CustomStepIcon';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        label: {
            marginBottom: '2px',
            marginLeft: 5
        },
        activeLabel: {
            marginBottom: '2px',
            marginLeft: 5,
            fontWeight: 500
        },
        iconContainer: {
            paddingRight: '0px',
            width: '36px'
        },
        step: {
            color: theme.palette.text.disabled,
            "& $completed": {
                fontWeight: 'normal',
                color: '#50832C'
            },
            "& $active": {
                fontWeight: 'normal',
                color: theme.palette.primary
            },
            "& $disabled": {
                fontWeight: 'normal',
                color: theme.palette.text.disabled
            }
        },
        active: {}, //needed so that the &$active tag works
        completed: {},
        disabled: {}
    }, globalStyles);
};

class CustomStep extends React.Component {

    render() {
        const { classes, label, index, activeStep } = this.props;

        return (
            <Step key={label}>
                <StepLabel completed={index < activeStep}
                    StepIconComponent={CustomStepIcon}
                    classes={{
                        label: index === activeStep ? classes.activeLabel : classes.label,
                        iconContainer: classes.iconContainer,
                        root: classes.step,
                        completed: classes.completed,
                        active: classes.active,
                        disabled: classes.disabled
                    }}
                    StepIconProps={{
                        index,
                        activeStep
                    }}
                >{label}</StepLabel>
            </Step>
        );
    }
}

CustomStep.propTypes = {
    label: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    activeStep: PropTypes.number.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(CustomStep);